<template lang="html">


  <div class="comentarios">
    <h6>{{$t('blog.dejar_comentario')}}</h6>
    <div class="cv-form container-text">

      <form @submit.prevent="validateBeforeSubmit" id="formComentario">
        <div class="flex row wrap justify-between">
          <div class="contenedor-input middle">
            <input type="text" class="input-text"
            :placeholder="$t('formulario.nombre')+'*'" name="nombre"
            v-model="data.nombre" v-validate="'required'"/>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
          </div>
          <div class="contenedor-input middle">
            <input type="text" class="input-text"
            :placeholder="$t('formulario.email')+'*'" name="email"
            v-model="data.email" v-validate="'required'"/>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
          </div>
          <div class="contenedor-input">
            <textarea :placeholder="$t('formulario.mensaje')+'*'"
            name="mensaje" v-model="data.texto" v-validate="'required'"></textarea>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
          </div>
        </div>

        <popup-condiciones v-on:launch="showCondiciones" :error="errorCondiciones"></popup-condiciones>

        <div class="contenedor-check contenedor-input" v-show="condiciones">
          <input id="checkbox2" type="checkbox" name="politica" v-model="politica" v-validate="'required'"/>
          <label for="checkbox2">{{$t('formulario.he_leido')}} <router-link target="_blank" :to="$t('enlaces.politica')">{{$t('formulario.y_acepto')}}</router-link>.</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
        </div>

        <div class="contenedor-check">
          <input id="checkbox3" type="checkbox" v-model="data.newsletter"/>
          <label for="checkbox3">{{$t('formulario.quiero_recibir')}}</label>
        </div>

        <span class="enviado-ok">{{$t('formulario.texto_comentario_enviado')}}</span>

        <button class="btn btn-dark -enviar" :clicked="sending" :sendend="sendend">
          <div class="scroller">
            <span>{{$t('formulario.enviar_comentario')}}</span>
            <span>
             <hollow-dots-spinner
             :animation-duration="1000"
             :dot-size="15"
             :dots-num="3"
             color="#054279"
             />
           </span>
           <span>{{$t('formulario.comentario_enviado')}}</span>
         </div>
       </button>

     </form>

   </div>
 </div>

</template>

<script lang="js">

  import popupCondiciones from '@/components/parts/popup-condiciones'

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import { HollowDotsSpinner } from 'epic-spinners'

  export default  {
    name: 'formulario-comentarios',
    props: [],
    mounted() {

    },
    data() {
      return {
        condiciones : false,
        clicked : false,
        politica : false,
        sending : false,
        sendend : false,
        data : {
          newsletter : false,
          nombre : '',
          email : '',
          texto : '',
          slug : this.$route.params.id,
        }
      }
    },
    methods: {
      showCondiciones : function(){
        this.condiciones = true;
      },
      validateBeforeSubmit : function(){

        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          (canSend) ? this.send() : '';
        });
      },
      send : function(){

        let data  = btoa(JSON.stringify(this.data));

        let that = this;
        this.sending = true;

        $.ajax({
         url: 'http://52.166.203.221/comentar',
         type: 'POST',
         dataType: 'json',
         async: true,
         data: {datos: data},
         headers: {"Authorization": "Basic " + btoa("mario:1234")}
       })
        .done(function(data) {
          setTimeout(function(){
            for(let e in that.data){that.data[e] = '';}
              that.sending = true;
            that.clicked = false;
            that.politica = false;
            that.sendend = true;
            $(".enviado-ok").addClass('animated fadeInUp')
          },100);

        });


      }
    },
    components: {
      'popup-condiciones' : popupCondiciones,
       HollowDotsSpinner
    },
    computed : {
     errorCondiciones : function(){
      let flag = (!this.condiciones && this.clicked) ? true : false;
      return flag;
    }
  }
}
</script>

<style scoped>
.contenedor-input .error{
  bottom: -14px;
}

.btn.-enviar{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 30px;
  width: 270px;
  height: 57px;
  padding: 0;
  outline: none;
}

.scroller{
  transition: .4s;
  width: 100%;
}
.btn[clicked="true"] .scroller{
  transform: translateY(-33.333333333%);
}

.btn[sendend="true"] .scroller{
 transform: translateY(-66.6666666666%);
}


.btn span{
  height: 57px;
  line-height: 57px;
  width: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-align-items: center;
  align-items: center;
  width: 100%;
}

.btn span:last-of-type{
  background: #054279;
  color: #fff;
}

.enviado-ok{
  width: 100%;
  text-align: center;
  display: inline-block;
  transform: translateY(20px);
  color: #054279;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/ficha-blog/formulario-comentarios.vue